module.exports = __webpack_public_path__ + "static/media/015.d7ad3781.jpg";